import { useState } from "react";
import { Message, User } from "../types";
import { uploadFile } from "../axios/uploadFiles";
import useAppStore from "../stores/appStore";

type SendMessage = React.Dispatch<React.SetStateAction<Message[]>>;

export const useFileUploader = (
  sendMessage: SendMessage,
  currentUser: User,
) => {
  const [isUploadingFile, setIsUploadingFile] = useState<boolean>(false);
  const { focus, domain } = useAppStore();

  const handleFileUpload = async (file: File, type: "file") => {
    if (!file) return;
    setIsUploadingFile(true);
    try {
      const fileResponse = await uploadFile(file, type);
      const finalURL = fileResponse.file_url;

      const fileMessage: Message = {
        message_id: String(Date.now() + Math.random()),
        from_user: currentUser,
        text: file.name,
        file_url: finalURL,
        type: type,
        is_bot: false,
        date: new Date().toISOString(),
        chat: {
          id: currentUser.id,
          type: "private",
        },
        user_id: currentUser.id,
        message_type: "default",
        domain: domain,
        focus: focus,
      };

      sendMessage((prev) => [...prev, fileMessage]);
    } catch (error) {
      console.error(`Failed to upload ${type}:`, error);
    } finally {
      setIsUploadingFile(false);
    }
  };

  return { isUploadingFile, handleFileUpload };
};
